import Indicatif from 'GroomyRoot/assets/lang/countries/indicatif'

export default Indicatif
